import { PageDocument } from 'src/constant/stringConstants';
import { Col, Row, Typography } from 'antd';
import { Content } from "antd/es/layout/layout";
import { useEffect } from 'react';
import TranslationKey from 'src/i18n/translation';
const { Title, Text } = Typography;
const imageLogo = require('../../assets/images/logo/white@3x.png');

export default function AboutUs() {
  useEffect(() => {
    document.title = `About Us - ${PageDocument.Title}`;
  }, []);

  const pageTextKey = 'aboutUs.';

  const buildParagraph = (
    titleKey: string,
    textKey: string,
    textKey2?: string) => {
    return (
      <>
        <Title className="text-light mb-0" level={3}>
          {TranslationKey(pageTextKey + titleKey)}
        </Title>
        <Text className="text-light fw-light">
          {TranslationKey(pageTextKey + textKey)}
        </Text>
        <br /><br />
        {
          textKey2 &&
          (
            <>
              <Text className="text-light fw-light">
                {TranslationKey(pageTextKey + textKey2)}
              </Text>
              <br /><br />
            </>
          )
        }
      </>
    );
  }

  return (
    <div className='container py-5 banner-margin-t-50'>
      <Row>
        <Col sm={24} md={24} lg={{ span: 20, offset: 2, }}  >
          <div className="flex-center">
            <img src={imageLogo} alt="" />
          </div>
          <Content className='text-center'>
            <Title className="text-light mb-0" level={2}>
              <span className="ms-2 text-gradient">
                {TranslationKey('aboutUs.uniqueCommunity')}
              </span>
            </Title>
            <Text className="text-gray">
              {TranslationKey('aboutUs.uniqueCommunityFor')}
            </Text>
          </Content>
          <Content className='text-start'>
            {buildParagraph('aliveUnited.title', 'aliveUnited.text1')}
            {buildParagraph('premiumQualityCollection.title', 'premiumQualityCollection.text1', 'premiumQualityCollection.text2')}
            {buildParagraph('collaborativeValue.title', 'collaborativeValue.text1')}
            {buildParagraph('contentPolicy.title', 'contentPolicy.text1')}
            {buildParagraph('freeCompAccessCurationServices.title', 'freeCompAccessCurationServices.text1')}
            {buildParagraph('meetTheTeam.title', 'meetTheTeam.text1')}
          </Content>
        </Col>
      </Row>
    </div>
  );
}